import {
  AIModel,
  ModelStatusListResponse,
  UserModelSettings,
  UserModelSettingsBulkResponse,
} from '../../types/modelTypes'
import { axiosClient } from '../axiosClient'

export const modelsFunctions = {
  async fetchModels(category?: string): Promise<AIModel[]> {
    const params = category ? { category } : {}
    return axiosClient.get('/api/models/', { params })
  },

  // Its own endpoint rather than widening the model list's shape.
  async fetchModelStatus(): Promise<ModelStatusListResponse> {
    return axiosClient.get('/api/models/status')
  },

  async fetchUserModelSettings(): Promise<UserModelSettingsBulkResponse> {
    return axiosClient.get('/api/models/settings')
  },

  async updateUserModelSettings(
    modelName: string,
    settings: Record<string, number | string>,
  ): Promise<UserModelSettings> {
    return axiosClient.put(`/api/models/settings/${encodeURIComponent(modelName)}`, { settings })
  },
}
